export default class Injury
{
    constructor(personal_info, injury_info, housing_info, loan_info, attachment_info){
        this.personal_info = personal_info
        this.injury_info = injury_info
        this.housing_info = housing_info
        this.loan_info = loan_info
        this.attachment_info = attachment_info
    }

    toFormData(){
        let fData = new FormData()
        
        //personal information for injury.
        fData.append('name1', this.personal_info.name1);
        fData.append('name2', this.personal_info.name2);
        fData.append('name3', this.personal_info.name3);
        fData.append('name4', this.personal_info.name4);
        fData.append('family_name', this.personal_info.family_name);
        fData.append('mother_name', this.personal_info.mother_name);
        fData.append('birth_date', this.personal_info.birth_date);
        fData.append('phone1', this.personal_info.phone1);
        fData.append('phone2', this.personal_info.phone2);    
        fData.append('marital_status_id', this.personal_info.marital_status_id);
        fData.append('certificate_id', this.personal_info.certificate_id);
        fData.append('number_children', this.personal_info.number_children);
        fData.append('religion_id', this.personal_info.religion_id);
        fData.append('nationalism_id', this.personal_info.nationalism_id);
        if(this.personal_info.id_type == '1'){
            fData.append('nationality_number', this.personal_info.nationality_number);
        }else{
            fData.append('national_id_number', this.personal_info.national_id_number);
        }
        
        //injury info.
        fData.append('date_wound', this.injury_info.date_wound);
        fData.append('place_wound', this.injury_info.place_wound);
        fData.append('dept', this.injury_info.dept);
        fData.append('place_wound_in_body', this.injury_info.place_wound_in_body);
        fData.append('disability_ratio', this.injury_info.disability_ratio);

        //housing info.
        fData.append('accommodation_id', this.housing_info.accommodation_id);
        fData.append('city_id', this.housing_info.city_id);
        fData.append('region', this.housing_info.region);
        fData.append('nearest_point', this.housing_info.nearest_point);
        fData.append('mahla', this.housing_info.mahla);
        fData.append('zqaq', this.housing_info.zqaq);
        fData.append('dar', this.housing_info.dar);

        //loan
        fData.append('grant_name', this.loan_info.grant_name);
        fData.append('borrower_name', this.loan_info.borrower_name);
        fData.append('received_date', this.loan_info.received_date);
        fData.append('amount', this.loan_info.amount);
        fData.append('amount_paid', this.loan_info.amount_paid);
        fData.append('amount_remaining', this.loan_info.amount_remaining);
        fData.append('bank_type_id', this.loan_info.bank_type_id);

        //attachment info.
        fData.append('attachment_basic', this.attachment_info.attachment_basic);
        if(typeof this.attachment_info.attachment_info == 'object')
            fData.append('attachment_info', this.attachment_info.attachment_info);
        fData.append('attachment_loan', this.attachment_info.attachment_loan);

        return fData
    }
}

